import type { TextProps } from "@emkit/builder-widgets";
import { useEditor } from "../../store.js";
import { RichTextEditor } from "../RichTextEditor.js";
import { ColorField, SelectField } from "./fields.js";
import type { WidgetInspectorProps } from "./registry.js";

const ALIGN = ["left", "center", "right"] as const;
const SIZE = ["sm", "base", "lg", "xl"] as const;

export function TextInspector({ widget }: WidgetInspectorProps) {
  const update = useEditor((s) => s.updateWidgetProps);
  const p = widget.props as TextProps;

  return (
    <>
      <div
        style={{
          padding: "0 16px 8px",
          fontSize: 11,
          color: "var(--fg-dim)",
        }}
      >
        Rich text — Ctrl+B bold · Ctrl+I italic · paste preserves formatting
      </div>
      <div style={{ padding: "0 16px 10px" }}>
        <RichTextEditor
          value={p.text}
          onChange={(html) => update(widget.id, { text: html })}
        />
      </div>
      <SelectField
        label="Size"
        value={p.size ?? "base"}
        options={SIZE}
        onChange={(v) => update(widget.id, { size: v })}
      />
      <SelectField
        label="Align"
        value={p.align ?? "left"}
        options={ALIGN}
        onChange={(v) => update(widget.id, { align: v })}
      />
      <ColorField
        label="Color"
        value={p.color ?? "#333333"}
        onChange={(v) => update(widget.id, { color: v })}
      />
    </>
  );
}
